import { Badge, BadgeProps as ChakraBadgeProps } from '@chakra-ui/react';
import { useStyleConfig } from '@chakra-ui/system';
import { mergeWith } from '@chakra-ui/utils';
import PropTypes from 'prop-types';
import React from 'react';

export const colorSchemePropTypes = ['neutral', 'warning', 'error', 'success', 'info'];

const propTypes = {
  colorScheme: PropTypes.oneOf(colorSchemePropTypes)
};
const defaultProps = {
  colorScheme: 'neutral'
};

export type StatusBadgeProps = ChakraBadgeProps;

const StatusBadge = (props: StatusBadgeProps & typeof defaultProps): React.ReactElement => {
  const { __css, colorScheme, ...rest } = props;

  const statusBadgeStyles = useStyleConfig('StatusBadge', props);

  return <Badge sx={mergeWith(statusBadgeStyles, __css)} {...rest} />;
};

StatusBadge.propTypes = propTypes;
StatusBadge.defaultProps = defaultProps;

export default StatusBadge;
